import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Vocab from '../components/VocabBank/Vocab'

const VocabBank = () => {
  return (
    <>
        <Navbar />
        <Vocab />
    </>
  )
}

export default VocabBank